import React from "react";
import { ChatMessage } from "../../services/api";

interface ChatTranscriptProps {
  messages: ChatMessage[];
  userLabel?: string;
  assistantLabel?: string;
  emptyMessage?: string;
  maxHeightClassName?: string;
}

const labelForRole = (
  role: string,
  userLabel: string,
  assistantLabel: string
): string => {
  if (role === "assistant") return assistantLabel;
  if (role === "system") return "System";
  return userLabel;
};

export const ChatTranscript: React.FC<ChatTranscriptProps> = ({
  messages,
  userLabel = "User",
  assistantLabel = "Agent",
  emptyMessage = "No chat transcript yet.",
  maxHeightClassName = "max-h-96",
}) => {
  if (!messages.length) {
    return (
      <div className="border border-dashed border-[var(--border)] rounded-lg p-6 text-center text-sm text-[var(--foreground-muted)]">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className={`space-y-3 overflow-y-auto pr-1 ${maxHeightClassName}`}>
      {messages.map((message, index) => {
        const isAssistant = message.role === "assistant";
        const isSystem = message.role === "system";
        return (
          <div
            key={`${message.role}-${index}`}
            className={`flex ${isAssistant || isSystem ? "justify-start" : "justify-end"}`}
          >
            <div
              className={`max-w-xs lg:max-w-md px-4 py-2 rounded-lg border ${
                isSystem
                  ? "bg-amber-50 text-amber-900 border-amber-200"
                  : isAssistant
                    ? "bg-[var(--muted)] text-[var(--foreground)] border-[var(--border)]"
                    : "bg-primary text-primary-foreground border-primary"
              }`}
            >
              <div className="text-xs font-medium mb-1 opacity-75">
                {labelForRole(message.role, userLabel, assistantLabel)}
              </div>
              <div className="text-sm whitespace-pre-wrap break-words">
                {message.content}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
